import type { IWarehouse } from '@nova/core';

import apiClient from './apiClient';

type AppointmentBolResponse = {
  id: string;
  originalDoc: {
    externalKey: string;
  };
  signedDoc: {
    externalKey: string;
  } | null;
};

type ValidateCheckoutForm = {
  licensePlate?: string;
  phoneNumber?: string;
};

export default {
  async getWarehouseInformation(warehouseId: string): Promise<Partial<IWarehouse>> {
    const response = await apiClient.get(`/checkout/public/${warehouseId}`);
    return response.data;
  },

  async validateCheckoutForm(warehouseId: string, formData: ValidateCheckoutForm) {
    const response = await apiClient.post(`/checkout/public/${warehouseId}/validate`, formData);
    return response.data;
  },

  async signBol(appointmentId: string, bolData: any) {
    const response = await apiClient.post(`/checkout/public/${appointmentId}/sign-bol`, bolData);
    return response.data;
  },

  async getBol(warehouseId: string, appointmentId: string): Promise<AppointmentBolResponse> {
    const response = await apiClient.post(`/checkout/public/${warehouseId}/bol`, { appointmentId });
    return response.data;
  },

  async sendBolEmailSms(warehouseId: string, contactData: any) {
    const response = await apiClient.post(`/checkout/public/${warehouseId}/send-bol`, contactData);
    return response.data;
  },

  async completeCheckout(warehouseId: string, checkoutData: any) {
    const response = await apiClient.post(`/checkout/public/${warehouseId}`, checkoutData);
    return response.data;
  }
};
